import { ReactComponent as User } from '../assets/icons/user.svg'
import { ReactComponent as Right } from '../assets/icons/board-right.svg'
import { ReactComponent as Left } from '../assets/icons/board-left.svg'
import { ReactComponent as Grid } from '../assets/icons/view-grid.svg'
import { ReactComponent as Main } from '../assets/icons/view-main.svg'
import { ReactComponent as Logout } from '../assets/icons/logout.svg'
// import { Link } from 'react-router-dom'

function Participants({ modalState, data }) {
  const studentsCount = data.filter((item) => item.isActive).length
  return (
    <button
      onClick={modalState}
      className='board:h-[52px] board:px-8 board:rounded-10 board:border-2 tab:h-40 tab:py-8 tab:pl-6 tab:rounded-8 tab:pr-8 box-border flex h-28 w-min items-center gap-8 rounded-4 border border-solid border-border-default bg-background-default py-[7px] pl-4 pr-6 shadow-emphasize hover:bg-background-alternative active:bg-background-alternative'
    >
      <User className='board:h-[38px] board:w-[38px] tab:h-30 tab:w-30 h-20 w-20' />
      <p className='text-caption2-medium board:text-h2-medium tab:text-body3-medium text-label-info'>{`${studentsCount}/${data.length}`}</p>
    </button>
  )
}

function Pagination({ data, currentPage, setCurrentPage, mode, patchApi }) {
  return (
    <div className='board:h-[52px] board:gap-24 board:rounded-10 board:border-2 board:px-[7px] board:py-8 tab:p-6 tab:rounded-8 tab:h-40 tab:gap-12 flex h-28 items-center gap-8 rounded-4 border border-solid border-border-default bg-background-default px-4 py-6 shadow-emphasize'>
      <button
        id='button-prev'
        onClick={(e) => {
          setCurrentPage(currentPage - 1)
          if (mode === 'FOCUS') {
            patchApi(currentPage - 1)
          }
          if (mode?.includes('GRID')) {
            // setCurrentPage(currentPage - 1)
            patchApi()
          } else return
        }}
        disabled={Boolean(currentPage === 1)}
        className={`${currentPage === 1 ? 'bg-background-alternative stroke-label-disable' : 'bg-primary-normal stroke-static-white hover:bg-border-active'} board:h-[38px] board:w-[38px] board:rounded-8 tab:h-[28px] tab:w-[28px] tab:rounded-6 flex h-20 w-20 items-center justify-center rounded-4`}
      >
        <Left id='button-prev' />
      </button>
      <p className='text-caption2-medium board:text-h2-medium tab:text-body3-medium text-label-info'>{`${currentPage}/${data.length}`}</p>
      <button
        id='button-next'
        onClick={(e) => {
          setCurrentPage(currentPage + 1)
          if (mode === 'FOCUS') {
            patchApi(currentPage + 1)
          }
          if (mode?.includes('GRID')) {
            setCurrentPage(currentPage + 1)
            patchApi()
          } else return
        }}
        disabled={Boolean(currentPage === data.length)}
        className={`${currentPage === data.length ? 'bg-background-alternative stroke-label-disable' : 'bg-primary-normal stroke-static-white hover:bg-border-active'} board:h-[38px] board:w-[38px] board:rounded-8 tab:rounded-6 tab:w-[28px] tab:h-[28px] flex h-20 w-20 items-center justify-center rounded-4`}
      >
        <Right id='button-next' />
      </button>
    </div>
  )
}

function MainViewSwitch({ modalState, onStateChange }) {
  return (
    <button
      onClick={onStateChange}
      className={`${modalState ? 'z-[1000]' : ''} tab:h-40 tab:w-40 tab:rounded-8 board:min-h-[52px] board:min-w-[52px] board:rounded-8 flex h-28 w-28 items-center justify-center rounded-4 bg-background-secondary shadow-emphasize hover:bg-background-hover`}
    >
      <Main id='button' />
    </button>
  )
}

function GridViewSwitch({ onStateChange }) {
  return (
    <button
      id='button'
      onClick={onStateChange}
      className='board:min-h-[52px] board:min-w-[52px] board:rounded-8 tab:w-40 tab:h-40 tab:rounded-8 flex h-28 w-28 items-center justify-center rounded-4 bg-background-secondary shadow-emphasize hover:bg-background-hover'
      //   className={`${modalState ? 'z-[1000]' : ''} flex min-h-[52px] w-min min-w-[52px] items-center justify-center rounded-8 bg-background-secondary shadow-emphasize hover:bg-background-hover`}
    >
      <Grid id='button' />
    </button>
  )
}

function ModeSwitch({ mode, onStateChange, modeModalState, disabledState, gridState }) {
  return (
    <div
      className={`${modeModalState || gridState ? 'z-[1000]' : ''} tab:rounded-8 board:rounded-10 flex items-center justify-center divide-x-[1px] divide-primary-normal overflow-hidden rounded-4 border-[1px] border-solid border-primary-normal shadow-emphasize has-[:disabled]:divide-border-default`}
      // className=''
    >
      <button
        id='button'
        onClick={() => {
          if (!modeModalState) {
            if (mode === 'INDIVIDUAL') {
              onStateChange()
              //   patchApi('FOCUS')
            }
            if (mode === 'INDIVIDUAL_GRID') {
              onStateChange()
              //   patchApi('FOCUS', true, '1ed2ce14-93a5-4965-964c-6855b7a0e9b5')
            }
          }
        }}
        className={`${mode.includes('FOCUS') ? (modeModalState ? 'bg-background-secondary' : 'bg-background-secondary hover:bg-background-hover') : modeModalState ? 'bg-background-default' : 'bg-background-default hover:bg-fill-normal'} tab:text-body3-medium tab:px-[22px] tab:py-[11.5px] board:px-28 board:py-12 text-caption2-semibold board:text-h2-semibold px-[17px] py-[6.5px] text-center text-primary-normal`}
      >
        수업집중
      </button>
      <button
        id='button'
        onClick={() => {
          if (!modeModalState && mode === 'FOCUS') {
            onStateChange()
            // patchApi('INDIVIDUAL')
            // getGridApi()
          }
          if (mode === 'FOCUS_GRID') {
            onStateChange()
            //   patchApi('FOCUS', true, '1ed2ce14-93a5-4965-964c-6855b7a0e9b5')
          }
        }}
        disabled={disabledState}
        className={`disabled:bg-background-alternative disabled:text-label-disable ${mode.includes('INDIVIDUAL') ? (modeModalState ? 'bg-background-secondary' : 'bg-background-secondary hover:bg-background-hover') : modeModalState ? 'bg-background-default' : 'bg-background-default hover:bg-fill-normal'} tab:text-body3-medium tab:px-[22px] tab:py-[11.5px] board:px-28 board:py-12 text-caption2-semibold board:text-h2-semibold px-[17px] py-[6.5px] text-center text-primary-normal`}
      >
        개별활동
      </button>
    </div>
  )
}

function DownloadBoards() {
  return (
    <button
      // onClick={() => postClassRoomOpenApi()}
      className='board:h-min button_solid_primary_sm board:board:button_solid_primary_lg text-caption2-semibold board:text-h2-medium board:py-12 tab:h-40 tab:text-body3-medium h-28 shadow-emphasize hover:bg-mint-40'
    >
      수업 보드 다운로드
    </button>
  )
}
function StartClass() {
  return (
    <button
      // onClick={() => postClassRoomOpenApi()}
      className='board:h-[52px] button_solid_primary_sm board:button_solid_primary_lg text-caption2-semibold board:text-h2-medium board:py-12 tab:text-body3-medium tab:h-40 h-28 shadow-emphasize hover:bg-mint-40'
    >
      수업 시작
    </button>
  )
}

function LogOut({ modalState, onStateChange, link, locationState }) {
  return (
    <div
      id='button'
      onClick={onStateChange}
      //   to={link}
      //   state={{ data: locationState }}
      //   className=''
      className={`${modalState ? 'z-[1000]' : 'hover:bg-mint-40'} board:min-h-[52px] board:w-min board:min-w-[52px] board:rounded-10 tab:h-40 tab:min-w-40 tab:rounded-8 flex h-28 w-28 items-center justify-center rounded-4 bg-border-active shadow-emphasize`}
    >
      <Logout id='button' className='board:h-42 board:w-42 h-18 w-18 tab:h-32 tab:w-32' />
    </div>
    // <div className='flex min-h-[62px] w-min min-w-[62px] items-center justify-center rounded-10 bg-border-active shadow-emphasize hover:bg-mint-40'>
    //   <Logout />
    // </div>
  )
}

export {
  Participants,
  Pagination,
  GridViewSwitch,
  MainViewSwitch,
  ModeSwitch,
  DownloadBoards,
  StartClass,
  LogOut,
}
